import LogUtil from '../../../core/utils/LogUtil';

/**
 * Payment Service
 * 결제 관련 비즈니스 로직
 */
export class PaymentService {
  constructor(paymentRepository) {
    this.paymentRepository = paymentRepository;
    LogUtil.log('🔧 [PaymentService] 초기화 완료');
  }

  /**
   * KSPAY 결제 결과 처리
   * @param {Object} paymentResult - KSPAY 결제 결과
   * @returns {Promise<BaseResponse<any>>}
   */
  async kspayCallback(paymentResult) {
    LogUtil.log('🔄 [PaymentService] KSPAY 콜백 처리 시작:', paymentResult);

    // 필수 파라미터 검증
    if (!paymentResult.ordno) {
      throw new Error('주문번호(ordno)가 누락되었습니다.');
    }

    const result = await this.paymentRepository.kspayCallback(paymentResult);
    LogUtil.log('✅ [PaymentService] KSPAY 콜백 처리 완료:', result);
    return result;
  }

  /**
   * 결제 정보 조회
   * @param {number} paymentId - 결제 ID
   * @returns {Promise<BaseResponse<any>>}
   */
  async getPayment(paymentId) {
    LogUtil.log('🔄 [PaymentService] 결제 정보 조회:', paymentId);

    if (!paymentId) {
      throw new Error('결제 ID가 필요합니다.');
    }

    return await this.paymentRepository.getPayment(paymentId);
  }

  /**
   * 주문별 결제 정보 조회
   * @param {number} orderId - 주문 ID
   * @returns {Promise<BaseResponse<any>>}
   */
  async getPaymentByOrder(orderId) {
    LogUtil.log('🔄 [PaymentService] 주문별 결제 조회:', orderId);

    if (!orderId) {
      throw new Error('주문 ID가 필요합니다.');
    }

    return await this.paymentRepository.getPaymentByOrder(orderId);
  }
}
